.innerAverageCell {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.stat {
    width: 50%;
    display: flex;
    flex-direction: column;
}
